<template>
  <div class="center-column">
    <!-- 本年/本月切换部件 -->
    <div class="time-toggle-bar">
      <div class="time-toggle">
        <span 
          :class="['toggle-item', { active: timeRange === 'month' }]" 
          @click="switchTimeRange('month')"
        >本月</span>
        <span 
          :class="['toggle-item', { active: timeRange === 'year' }]" 
          @click="switchTimeRange('year')"
        >本年</span>
      </div>
    </div>
    <div class="dashboard-grid">
      <!-- 第一行一列：项目卡片 -->
      <div class="dashboard-item project-card">
        <div class="project-header">
          <div class="card-title" :title="projectCard.title">{{ projectCard.title }}</div>
          <div class="project-total" :title="`项目总数：${projectCard.total}`">
            已投标总数：<span class="total-number" :title="projectCard.total">{{ projectCard.total }}</span>
          </div>
        </div>
        
        <div class="project-card-content">
          <!-- 分段进度条 -->
          <div class="segment-bar">
            <div class="segment-bar-wrapper">
              <div 
                v-for="segment in projectCard.segments" 
                :key="segment.name"
                class="segment-item" 
                :class="getSegmentClass(segment.name)"
                :style="{ width: calculatePercentage(segment.value, projectCard.total) + '%' }"
                :title="`${segment.name}：${calculatePercentage(segment.value, projectCard.total)}%`"
              ></div>
            </div>
            <div class="segment-labels">
              <span 
                v-for="segment in projectCard.segments" 
                :key="segment.name"
                class="segment-label" 
                :class="getSegmentLabelClass(segment.name)"
                :title="`${segment.name}：${calculatePercentage(segment.value, projectCard.total)}%`"
              >{{ segment.name }}：{{ calculatePercentage(segment.value, projectCard.total) }}%</span>
            </div>
          </div>
          
          <!-- 分布图 -->
          <div class="distribution-chart">
            <div class="donut-chart-container" ref="donutChart1"></div>
            <div class="distribution-title" :title="donutChart1Title">{{ donutChart1Title }}</div>
          </div>
        </div>
      </div>
      
      <!-- 第一行二列：售后卡片 -->
      <div class="dashboard-item project-card">
        <div class="project-header">
          <div class="card-title" :title="afterSalesCard.title">{{ afterSalesCard.title }}</div>
          <div class="project-total" :title="`进行中售后总数：${afterSalesCard.total}`">
            进行中售后总数：<span class="total-number" :title="afterSalesCard.total">{{ afterSalesCard.total }}</span>
          </div>
        </div>
        
        <div class="project-card-content">
          <!-- 分段进度条 -->
          <div class="segment-bar">
            <div class="segment-bar-wrapper">
              <div 
                v-for="segment in afterSalesCard.segments" 
                :key="segment.name"
                class="segment-item" 
                :class="getSegmentClass(segment.name)"
                :style="{ width: calculatePercentage(segment.value, afterSalesCard.total) + '%' }"
                :title="`${segment.name}：${calculatePercentage(segment.value, afterSalesCard.total)}%`"
              ></div>
            </div>
            <div class="segment-labels">
              <span 
                v-for="segment in afterSalesCard.segments" 
                :key="segment.name"
                class="segment-label" 
                :class="getSegmentLabelClass(segment.name)"
                :title="`${segment.name}：${calculatePercentage(segment.value, afterSalesCard.total)}%`"
              >{{ segment.name }}：{{ calculatePercentage(segment.value, afterSalesCard.total) }}%</span>
            </div>
          </div>
          
          <!-- 分布图 -->
          <div class="distribution-chart">
            <div class="donut-chart-container" ref="donutChart2"></div>
            <div class="distribution-title" :title="donutChart2Title">{{ donutChart2Title }}</div>
          </div>
        </div>
      </div>
      
      <!-- 第二行一列：合同进度卡片 -->
      <div class="dashboard-item project-card">
        <div class="project-header">
          <div class="card-title" :title="contractProgressCard.title">{{ contractProgressCard.title }}</div>
          <div class="project-total" :title="`合同总数：${contractProgressCard.total}`">
            合同总数：<span class="total-number" :title="contractProgressCard.total">{{ contractProgressCard.total }}</span>
          </div>
        </div>
        
        <div class="project-card-content">
          <!-- 分段进度条 -->
          <div class="segment-bar">
            <div class="segment-bar-wrapper">
              <div 
                v-for="segment in contractProgressCard.segments" 
                :key="segment.name"
                class="segment-item" 
                :class="getSegmentClass(segment.name)"
                :style="{ width: calculatePercentage(segment.value, contractProgressCard.total) + '%' }"
                :title="`${segment.name}：${calculatePercentage(segment.value, contractProgressCard.total)}%`"
              ></div>
            </div>
            <div class="segment-labels">
              <span 
                v-for="segment in contractProgressCard.segments" 
                :key="segment.name"
                class="segment-label" 
                :class="getSegmentLabelClass(segment.name)"
                :title="`${segment.name}：${calculatePercentage(segment.value, contractProgressCard.total)}%`"
              >{{ segment.name }}：{{ calculatePercentage(segment.value, contractProgressCard.total) }}%</span>
            </div>
          </div>
          
          <!-- 分布图 -->
          <div class="distribution-chart">
            <div class="donut-chart-container" ref="donutChart3"></div>
            <div class="distribution-title" :title="donutChart3Title">{{ donutChart3Title }}</div>
          </div>
        </div>
      </div>
 
      
      <!-- 第二行二列：任务单进度卡片 -->
      <div class="dashboard-item project-card">
        <div class="project-header">
          <div class="card-title" :title="taskProgressCard.title">{{ taskProgressCard.title }}</div>
          <div class="project-total" :title="`任务单总数：${taskProgressCard.total}`">
            任务单总数：<span class="total-number" :title="taskProgressCard.total">{{ taskProgressCard.total }}</span>
          </div>
        </div>
        
        <div class="project-card-content">
          <!-- 分段进度条 -->
          <div class="segment-bar">
            <div class="segment-bar-wrapper">
              <div 
                v-for="segment in taskProgressCard.segments" 
                :key="segment.name"
                class="segment-item" 
                :class="getSegmentClass(segment.name)"
                :style="{ width: calculatePercentage(segment.value, taskProgressCard.total) + '%' }"
                :title="`${segment.name}：${calculatePercentage(segment.value, taskProgressCard.total)}%`"
              ></div>
            </div>
            <div class="segment-labels">
              <span 
                v-for="segment in taskProgressCard.segments" 
                :key="segment.name"
                class="segment-label" 
                :class="getSegmentLabelClass(segment.name)"
                :title="`${segment.name}：${calculatePercentage(segment.value, taskProgressCard.total)}%`"
              >{{ segment.name }}：{{ calculatePercentage(segment.value, taskProgressCard.total) }}%</span>
            </div>
          </div>
          
          <!-- 分布图 -->
          <div class="distribution-chart">
            <div class="donut-chart-container" ref="donutChart5"></div>
            <div class="distribution-title" :title="donutChart5Title">{{ donutChart5Title }}</div>
          </div>
        </div>
      </div>



      <!-- 第三行一列：合同异常卡片 -->
      <div class="dashboard-item project-card">
        <div class="project-header">
          <div class="card-title" :title="contractExceptionCard.title">{{ contractExceptionCard.title }}</div>
          <div class="project-total" :title="`进行中合同总数：${contractExceptionCard.total}`">
            合同异常总数：<span class="total-number" :title="contractExceptionCard.total">{{ contractExceptionCard.total }}</span>
          </div>
        </div>
        
        <div class="project-card-content">

          
          <!-- 分布图 -->
          <div class="distribution-chart">
            <div class="donut-chart-container" ref="donutChart4"></div>
            <div class="distribution-title" :title="donutChart4Title">{{ donutChart4Title }}</div>
          </div>
        </div>
      </div>
      

      
      <!-- 第三行二列：任务单异常卡片 -->
      <div class="dashboard-item project-card">
        <div class="project-header">
          <div class="card-title" :title="taskExceptionCard.title">{{ taskExceptionCard.title }}</div>
          <div class="project-total" :title="`已开工任务单总数：${taskExceptionCard.total}`">
            生产异常总数：<span class="total-number" :title="taskExceptionCard.total">{{ taskExceptionCard.total }}</span>
          </div>
        </div>
        
        <div class="project-card-content">
  
          
          <!-- 分布图 -->
          <div class="distribution-chart">
            <div class="donut-chart-container" ref="donutChart6"></div>
            <div class="distribution-title" :title="donutChart6Title">{{ donutChart6Title }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as echarts from 'echarts';
import { PieChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';
import { UniversalTransition } from 'echarts/features';
import { TooltipComponent } from 'echarts/components';
// import { getDashboardCardData } from '@/api/mainapi.js'


export default {
  name: 'DashboardCards',
  props: {
    dashboardData: Object
  },

  watch: {
    dashboardData: {
      immediate: true,
      handler(val) {
        if (!val) return
        this.updateCardsDataFromRealApi(val)
      }
    }
  },  
  data() {
    return {
      // 当前时间范围：month-本月, year-本年
      timeRange: 'month',
      // 卡片数据
      projectCard: {
        donutChartsData: [], // 确保初始化为空数组
        title: '项目',
        total: 0,
        segments: [
          { name: '中标', value: 0, color: '#1DD1A1' },
          { name: '进行中', value: 0, color: '#FECA57' },
          { name: '未中标', value: 0, color: '#FF6B6B' }
        ],
        donutChart: {
          title: '中标项目大类分布',
          data: []
        }
      },
      afterSalesCard: {
        title: '售后',
        total: 0,
        segments: [
          { name: '正常', value: 0, color: '#1DD1A1' },
          { name: '异常', value: 0, color: '#FF6B6B' }
        ],
        donutChart: {
          title: '售后异常情况分布',
          data: []
        }
      },
      contractProgressCard: {
        title: '合同进度',
        total: 0,
        segments: [
          { name: '已审核', value: 0, color: '#1DD1A1' },
          { name: '未审核', value: 0, color: '#FF6B6B' }
        ],
        donutChart: {
          title: '合同履约进度分布',
          data: []
        }
      },
      contractExceptionCard: {
        title: '销售异常',
        total: 0,
        segments: [
          { name: '正常', value: 0, color: '#1DD1A1' },
          { name: '异常', value: 0, color: '#FF6B6B' }
        ],
        donutChart: {
          title: '合同异常情况分布',
          data: []
        }
      },
      taskProgressCard: {
        title: '任务进度',
        total: 0,
        segments: [
          { name: '已开工', value: 0, color: '#1DD1A1' },
          { name: '未开工', value: 0, color: '#FF6B6B' }
        ],
        donutChart: {
          title: '任务单生产进度分布',
          data: []
        }
      },
      taskExceptionCard: {
        title: '任务单异常',
        total: 0,
        segments: [
          { name: '正常', value: 0, color: '#1DD1A1' },
          { name: '异常', value: 0, color: '#FF6B6B' }
        ],
        donutChart: {
          title: '任务异常情况分布',
          data: []
        }
      },
      
      // 环形图数据
      donutChartsData: [],
      
      // 加载状态
      loading: false,
      

    };
  },
  computed: {
    // 环形图标题计算属性
    donutChart1Title() {
      return (this.donutChartsData[0] && this.donutChartsData[0].title) || '中标项目大类分布';
    },
    donutChart2Title() {
      return (this.donutChartsData[1] && this.donutChartsData[1].title) || '售后异常情况分布';
    },
    donutChart3Title() {
      return (this.donutChartsData[2] && this.donutChartsData[2].title) || '合同履约进度分布';
    },
    donutChart4Title() {
      return (this.donutChartsData[3] && this.donutChartsData[3].title) || '合同异常情况分布';
    },
    donutChart5Title() {
      return (this.donutChartsData[4] && this.donutChartsData[4].title) || '任务单生产进度分布';
    },
    donutChart6Title() {
      return (this.donutChartsData[5] && this.donutChartsData[5].title) || '任务异常情况分布';
    }
  },
  mounted() {
    this.$nextTick(() => {
      echarts.use([
        PieChart,
        TooltipComponent,
        CanvasRenderer,
        UniversalTransition
      ]);
      
      // 获取所有卡片数据
      // this.getAllCardsData();
    });
  },
  methods: {
    /**
     * 切换时间范围（本月/本年）
     */
    switchTimeRange(range) {
      if (this.timeRange === range) return
      this.timeRange = range
      // 通知父组件重新加载数据
      this.$emit('timeRangeChange', range)
    },
    /**
     * 获取所有卡片数据
     */
// async getAllCardsData() {
//   this.loading = true
//   try {
//     const res = await getDashboardCardData({
//       startDate: '2026-06-01',
//       currentDate: '2026-06-11'
//     })

//     if (res.data.code === 200) {
//       this.updateCardsDataFromRealApi(res.data.data)
//     } else {
//       console.warn('真实接口异常，使用 mock 数据')
//       this.useDefaultData()
//     }
//   } catch (err) {
//     console.error('接口请求失败，使用 mock 数据', err)
//     this.useDefaultData()
//   } finally {
//     this.loading = false
//   }
// },

updateCardsDataFromRealApi(data) {
  const {
    project,
    afterSales,
    afterSalesException,
    contract,
    contractException,
    taskInfo,
    productionException
  } = data

  /** ========= 项目卡片 ========= */
  this.projectCard = {
    title: '项目',
    total: project.bidTotalCount,
    segments: [
      {
        name: '中标',
        value: Math.round(project.bidTotalCount * project.winBidCountRate / 100),
        color: '#1DD1A1'
      },
      {
        name: '进行中',
        value: Math.round(project.bidTotalCount * project.biddingCountRate / 100),
        color: '#FECA57'
      },
      {
        name: '未中标',
        value: Math.round(project.bidTotalCount * project.loseBidCountRate / 100),
        color: '#FF6B6B'
      }
    ],
    donutChart: {
      title: '中标项目大类分布',
      // FANTODO:后端大类暂无，重复显示中标情况占比
      data: [
        {
          name: '中标',
          value: project.winBidCountRate,
        },
        {
          name: '进行中',
          value: project.biddingCountRate,
        },
        {
          name: '未中标',
          value: project.loseBidCountRate,
        }
      ]
    }
  }

  /** ========= 售后卡片 ========= */
  this.afterSalesCard = {
    title: '售后',
    total: Number(afterSales.totalCount),
    segments: [
      {
        name: '已完成',
        value: Number(afterSales.finishedCount),
      },
      {
        name: '未完成',
        value: Number(afterSales.unfinishedCount),
      }
    ],
    donutChart: {
      title: '售后异常情况分布',
      data: [
        { name: '领料返修异常', value: afterSalesException.领料返修异常占比, color: '#FF6B6B' },
        { name: '现场服务异常', value: afterSalesException.现场服务异常占比, color: '#FECA57' },
        { name: '受理派单异常', value: afterSalesException.受理派单异常占比, color: '#0595eb' },
        { name: '其他售后异常', value: afterSalesException.其他售后异常占比, color: '#8EB5C9' }
      ]
    }
  }

  /** ========= 合同进度 ========= */
  const c = contract.result
  this.contractProgressCard = {
    title: '合同进度',
    total: c.合同总数,
    segments: [
      { name: '已审核', value: c.已审核合同总数, color: '#1DD1A1' },
      { name: '未审核', value: c.未审核合同数, color: '#FF6B6B' }
    ],
    donutChart: {
      title: '合同履约进度分布',
      data: [
        {
          name: '已审核',
          value: Number((c.已审核合同占比 * 100).toFixed(2)),
          color: '#1DD1A1'
        },
        {
          name: '暂存',
          value: Number((c.暂存合同占比 * 100).toFixed(2)),
          color: '#00aeff'
        },
        {
          name: '已提交',
          value: Number((c.已提交合同占比 * 100).toFixed(2)),
          color: '#74efff'
        }
      ]
    }
  }

  /** ========= 生产进度 ========= */
  this.taskProgressCard = {
    title: '生产进度',
    total: taskInfo.任务单总数量,
    segments: [
      { name: '已开工', value: Math.round(taskInfo.任务单总数量 * taskInfo.已开工占比), color: '#1DD1A1' },
      { name: '未开工', value: Math.round(taskInfo.任务单总数量 * taskInfo.未开工占比), color: '#FF6B6B' }
    ],
    donutChart: {
      title: '任务单生产进度分布',
data: [
  {
    name: '下达',
    value: Number((taskInfo.下达占比 * 100).toFixed(2)),
    color: '#FECA57'
  },
  {
    name: '结案',
    value: Number((taskInfo.结案占比 * 100).toFixed(2)),
    color: '#0595eb'
  },
  {
    name: '未开工',
    value: Number((taskInfo.未开工占比 * 100).toFixed(2)),
    color: '#1DD1A1'
  },
  {
    name: '确认',
    value: Number((taskInfo.确认占比 * 100).toFixed(2)),
    color: '#74efff'
  }
]
    }     
  }

  /** ========= 销售异常 ========= */
  this.contractExceptionCard = {
    title: '销售异常',
    total: contractException.合同异常总数,

    donutChart: {
      title: '合同异常情况分布',
      data: [
        { name: '合同变更', value: contractException.合同变更占比, color: '#FF6B6B' },
        { name: 'ERP同步异常', value: contractException.ERP同步异常占比, color: '#FECA57' },
        { name: '执行评审异常', value: contractException.执行评审异常占比, color: '#0595eb' },
        { name: '签订异常', value: contractException.签订异常占比, color: '#8EB5C9' }
      ]
    }
  }

  /** ========= 生产异常 ========= */
  this.taskExceptionCard = {
    title: '生产异常',
    total: productionException.生产异常总数,
    donutChart: {
      title: '任务异常情况分布',
      data: [
    {
      name: '采购订单超期',
      value: Number((productionException.采购订单超期占比 * 100).toFixed(2)),
      color: '#FF6B6B'
    },
    {
      name: '生产超期',
      value: Number((productionException.生产超期占比 * 100).toFixed(2)),
      color: '#FECA57'
    },
    {
      name: '结案超期',
      value: Number((productionException.结案超期占比 * 100).toFixed(2)),
      color: '#0595eb'
    },
    {
      name: '入库超期',
      value: Number((productionException.入库超期占比 * 100).toFixed(2)),
      color: '#8EB5C9'
    },
    {
      name: '报工异常',
      value: Number((productionException.报工异常占比 * 100).toFixed(2)),
      color: '#1DD1A1'
    },
    {
      name: '任务下达齐套率异常',
      value: Number((productionException.任务下达齐套率异常占比 * 100).toFixed(2)),
      color: '#74efff'
    }
  ]
    }
  }

  // 初始化环形图
  this.initAllDonutChartsFromCards({
    projectCard: this.projectCard,
    afterSalesCard: this.afterSalesCard,
    contractProgressCard: this.contractProgressCard,
    contractExceptionCard: this.contractExceptionCard,
    taskProgressCard: this.taskProgressCard,
    taskExceptionCard: this.taskExceptionCard
  })
},    
    // /**
    //  * 更新卡片数据
    //  */
    // updateCardsData(cards) {
    //   // 更新项目卡片
    //   if (cards.projectCard) {
    //     this.projectCard = {
    //       ...this.projectCard,
    //       ...cards.projectCard
    //     };
    //   }
      
    //   // 更新售后卡片
    //   if (cards.afterSalesCard) {
    //     this.afterSalesCard = {
    //       ...this.afterSalesCard,
    //       ...cards.afterSalesCard
    //     };
    //   }
      
    //   // 更新合同进度卡片
    //   if (cards.contractProgressCard) {
    //     this.contractProgressCard = {
    //       ...this.contractProgressCard,
    //       ...cards.contractProgressCard
    //     };
    //   }
      
    //   // 更新合同异常卡片
    //   if (cards.contractExceptionCard) {
    //     this.contractExceptionCard = {
    //       ...this.contractExceptionCard,
    //       ...cards.contractExceptionCard
    //     };
    //   }
      
    //   // 更新任务单进度卡片
    //   if (cards.taskProgressCard) {
    //     this.taskProgressCard = {
    //       ...this.taskProgressCard,
    //       ...cards.taskProgressCard
    //     };
    //   }
      
    //   // 更新任务单异常卡片
    //   if (cards.taskExceptionCard) {
    //     this.taskExceptionCard = {
    //       ...this.taskExceptionCard,
    //       ...cards.taskExceptionCard
    //     };
    //   }
      
    //   // 初始化环形图
    //   this.initAllDonutChartsFromCards(cards);
    // },
    
    // /**
    //  * 使用默认数据
    //  */
    // useDefaultData() {
    //   this.projectCard = { ...this.projectCard, ...this.defaultCardsData.projectCard };
    //   this.afterSalesCard = { ...this.afterSalesCard, ...this.defaultCardsData.afterSalesCard };
    //   this.contractProgressCard = { ...this.contractProgressCard, ...this.defaultCardsData.contractProgressCard };
    //   this.contractExceptionCard = { ...this.contractExceptionCard, ...this.defaultCardsData.contractExceptionCard };
    //   this.taskProgressCard = { ...this.taskProgressCard, ...this.defaultCardsData.taskProgressCard };
    //   this.taskExceptionCard = { ...this.taskExceptionCard, ...this.defaultCardsData.taskExceptionCard };
      
    //   // 初始化默认环形图
    //   this.initDefaultDonutCharts();
    // },
    

    
    /**
     * 初始化默认环形图
     */
    initDefaultDonutCharts() {
      this.donutChartsData = this.defaultDonutChartsData;
      this.initAllDonutChartsFromData(this.defaultDonutChartsData);
    },
    
    /**
     * 从数据初始化环形图
     */
    initAllDonutChartsFromData(chartsData) {
      chartsData.forEach(chartData => {
        this.initDonutChart(chartData.chartRef, chartData);
      });
    },
    
    /**
     * 从卡片数据初始化环形图
     */
    initAllDonutChartsFromCards(cards) {
      const chartConfigs = [
        { chartRef: 'donutChart1', config: cards.projectCard.donutChart },
        { chartRef: 'donutChart2', config: cards.afterSalesCard.donutChart },
        { chartRef: 'donutChart3', config: cards.contractProgressCard.donutChart },
        { chartRef: 'donutChart4', config: cards.contractExceptionCard.donutChart },
        { chartRef: 'donutChart5', config: cards.taskProgressCard.donutChart },
        { chartRef: 'donutChart6', config: cards.taskExceptionCard.donutChart }
      ];
      
      chartConfigs.forEach(({ chartRef, config }) => {
        if (config) {
          this.initDonutChart(chartRef, config);
        }
      });
    },
    
    /**
     * 计算百分比
     */
    calculatePercentage(value, total) {
      if (!total) return 0;
      return Math.round((value / total) * 100);
    },
    
    /**
     * 获取分段样式类
     */
    getSegmentClass(segmentName) {
      const classMap = {
        '中标': 'segment-won',
        '进行中': 'segment-inprogress',
        '未中标': 'segment-lost',
        '正常': 'segment-normal',
        '异常': 'segment-abnormal',
        '已完成': 'segment-normal',
        '未完成': 'segment-abnormal',
        '已审核': 'segment-reviewed',
        '未审核': 'segment-unreviewed',
        '已开工': 'segment-started',
        '未开工': 'segment-unstarted'
      };
      return classMap[segmentName] || 'segment-normal';
    },
    
    /**
     * 获取分段标签样式类
     */
    getSegmentLabelClass(segmentName) {
      const classMap = {
        '中标': 'won-label',
        '进行中': 'inprogress-label',
        '未中标': 'lost-label',
        '正常': 'normal-label',
        '异常': 'abnormal-label',
        '已完成': 'normal-label',
        '未完成': 'abnormal-label',
        '已审核': 'reviewed-label',
        '未审核': 'unreviewed-label',
        '已开工': 'started-label',
        '未开工': 'unstarted-label'
      };
      return classMap[segmentName] || 'normal-label';
    },
    
    /**
     * 初始化单个环形图
     */
initDonutChart(chartRef, chartConfig) {
  const chartDom = this.$refs[chartRef];
  if (!chartDom) return;

  const chart = echarts.init(chartDom);

  const option = {
    tooltip: {
      trigger: 'item',
      formatter: '{b}：{c}%',
      backgroundColor: 'rgba(5, 149, 235, 0.9)',
      borderColor: '#00aeff',
      textStyle: {
        color: '#fff',
        fontSize: 12
      }
    },
    series: [
      {
        name: chartConfig.title,
        type: 'pie',
        radius: ['48%', '68%'],
        center: ['50%', '50%'],
        minShowLabelAngle: 0,
        avoidLabelOverlap: true,

        itemStyle: {
          borderRadius: 4,
          borderColor: 'rgba(5, 149, 235, 0.3)',
          borderWidth: 1
        },

        label: {
          show: true,
          position: 'outside',
          formatter: params => `${params.name}\n${params.percent}%`,
          fontSize: 11,
          color: '#cdddf7',
          fontWeight: 'bold',
          lineHeight: 14
        },

        labelLine: {
          show: true,
          length: 8,
          length2: 10,
          smooth: true,
          lineStyle: {
            color: 'rgba(205, 221, 247, 0.35)',
            width: 1
          }
        },

        emphasis: {
          scale: true,
          scaleSize: 4,
          itemStyle: {
            shadowBlur: 8,
            shadowColor: 'rgba(0, 174, 255, 0.3)'
          }
        },

        data: chartConfig.data.map(item => {
          const isZero = item.value === 0;

          return {
            value: item.value,
            name: item.name,
            itemStyle: { color: item.color },

            // ✅ 0%：无引导线，字号略小
            ...(isZero && {
              label: {
                show: true,
                position: 'outside',
                fontSize: 10,
                color: 'rgba(205, 221, 247, 0.85)',
                fontWeight: 'normal',
                formatter: params => `${params.name}\n0%`,
                lineHeight: 13
              },
              labelLine: {
                show: false
              }
            }),

            // ✅ >0%：有引导线
            ...(!isZero && {
              label: {
                show: true,
                position: 'outside',
                fontSize: 11,
                color: '#cdddf7',
                fontWeight: 'bold',
                formatter: params => `${params.name}\n${params.percent}%`,
                lineHeight: 14
              },
              labelLine: {
                show: true
              }
            })
          };
        })
      }
    ]
  };

  chart.setOption(option);

  window.addEventListener('resize', () => chart.resize());

  const resizeObserver = new ResizeObserver(() => chart.resize());
  resizeObserver.observe(chartDom);
}
  }
};
</script>





<style scoped>
/* 中间区域样式 */
.center-column {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  box-sizing: border-box;
}

/* ==================== 时间范围切换部件 ==================== */
.time-toggle-bar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 0 8px 0;
  flex-shrink: 0;
}

.time-toggle {
  display: flex;
  background: rgba(5, 149, 235, 0.1);
  border: 1px solid rgba(5, 149, 235, 0.3);
  border-radius: 6px;
  overflow: hidden;
}

.toggle-item {
  padding: 4px 16px;
  font-size: 13px;
  color: #8EB5C9;
  cursor: pointer;
  transition: all 0.3s ease;
  user-select: none;
  white-space: nowrap;
}

.toggle-item:hover {
  color: #74efff;
  background: rgba(5, 149, 235, 0.2);
}

.toggle-item.active {
  color: #fff;
  background: linear-gradient(135deg, #0595eb, #00aeff);
  font-weight: bold;
}

.toggle-item + .toggle-item {
  border-left: 1px solid rgba(5, 149, 235, 0.3);
}

.dashboard-grid {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(3, 1fr);
  gap: 10px;
  overflow: hidden;
  height: 100%;
  box-sizing: border-box;
  min-height: 0;
}

.dashboard-item {
  background: rgba(5, 149, 235, 0.1);
  border: 1px solid rgba(5, 149, 235, 0.3);
  border-radius: 8px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  min-height: 0;
  height: 100%;
  box-sizing: border-box;
}

.dashboard-item:hover {
  transform: translateY(-3px);
  box-shadow: 0 3px 15px rgba(5, 149, 235, 0.3);
  border-color: #74efff;
}

/* ==================== 卡片标题区域 ==================== */
.project-header {
  margin-bottom: 8px;
  padding-bottom: 6px;
  border-bottom: 1px solid rgba(0, 174, 255, 0.3);
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: auto;
  min-height: 28px;
  flex-shrink: 0;
  box-sizing: border-box;
  gap: 8px;
  width: 100%;
}

/* 卡片标题 - 使用clamp()实现响应式字体缩放 */
.card-title {
  color: #cdddf7;
  /* 使用clamp()实现响应式字体：最小12px，理想值基于计算，最大16px */
  font-size: clamp(
    0.75rem,  /* 最小：12px */
    calc(0.7rem + 0.8vmin), /* 动态计算：基础0.7rem + 基于视口最小尺寸 */
    1rem      /* 最大：16px */
  );
  font-weight: bold;
  background: linear-gradient(45deg, #00aeff, #74efff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  flex-shrink: 0;
  line-height: 1.2;
  /* 防止换行，超出显示... */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  transition: font-size 0.3s ease;
  position: relative;
  padding-right: 2px;
}

/* 项目总数文本 - 使用clamp()实现响应式字体缩放 */
.project-total {
  color: #8EB5C9;
  /* 使用clamp()实现响应式字体：最小10px，理想值基于计算，最大12px */
  font-size: clamp(
    0.625rem,  /* 最小：10px */
    calc(0.6rem + 0.5vmin), /* 动态计算 */
    0.75rem    /* 最大：12px */
  );
  font-weight: normal;
  margin-bottom: 0;
  text-align: right;
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  line-height: 1.2;
  min-width: 0;
  /* 防止换行，超出显示... */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  transition: font-size 0.3s ease;
  cursor: default;
  padding-left: 4px;
}

/* 总数数字 - 使用clamp()实现响应式字体缩放 */
.total-number {
  color: #74efff;
  /* 使用clamp()实现响应式字体：最小12px，理想值基于计算，最大16px */
  font-size: clamp(
    0.75rem,  /* 最小：12px */
    calc(0.7rem + 0.8vmin), /* 动态计算 */
    1rem      /* 最大：16px */
  );
  font-weight: bold;
  margin-left: 4px;
  background: linear-gradient(45deg, #00aeff, #74efff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  line-height: 1.2;
  /* 防止换行 */
  white-space: nowrap;
  overflow: visible;
  flex-shrink: 0;
  transition: font-size 0.3s ease;
}

.project-card-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  gap: 8px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

/* ==================== 分段进度条区域 ==================== */
.segment-bar {
  margin-bottom: 0;
  flex-shrink: 0;
  height: auto;
  min-height: 30px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
}

.segment-bar-wrapper {
  width: 100%;
  height: 3px;
  background-color: rgba(142, 181, 201, 0.1);
  border-radius: 6px;
  overflow: hidden;
  display: flex;
  border: 1px solid rgba(142, 181, 201, 0.3);
  box-sizing: border-box;
}

.segment-item {
  height: 100%;
  transition: all 0.3s ease;
  position: relative;
  cursor: pointer;
  box-sizing: border-box;
}

.segment-item:hover {
  opacity: 0.9;
  box-shadow: 0 0 8px rgba(255, 255, 255, 0.3);
}

/* 分段进度条标签容器 */
.segment-labels {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 4px;
  width: 100%;
  box-sizing: border-box;
  min-height: 0;
  padding: 0 2px;
}

/* 分段标签 - 使用clamp()实现响应式字体缩放 */
.segment-label {
  display: flex;
  align-items: center;
  padding: 2px 4px;
  border-radius: 2px;
  background-color: rgba(142, 181, 201, 0.1);
  border: 1px solid rgba(142, 181, 201, 0.2);
  transition: all 0.3s ease;
  box-sizing: border-box;
  /* 使用clamp()实现响应式字体：最小8px，理想值基于计算，最大11px */
  font-size: clamp(
    0.5rem,   /* 最小：8px */
    calc(0.5rem + 0.4vmin), /* 动态计算 */
    0.688rem  /* 最大：11px */
  );
  color: #8EB5C9;
  /* 防止换行，超出显示... */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  min-width: 0;
  flex: 1;
  justify-content: center;
  text-align: center;
  line-height: 1.2;
}

.segment-label:hover {
  transform: translateY(-2px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

/* 各种标签颜色 */
.won-label { color: #1DD1A1; border-color: rgba(29, 209, 161, 0.3); }
.inprogress-label { color: #FECA57; border-color: rgba(254, 202, 87, 0.3); }
.lost-label { color: #FF6B6B; border-color: rgba(255, 107, 107, 0.3); }
.normal-label { color: #1DD1A1; border-color: rgba(29, 209, 161, 0.3); }
.abnormal-label { color: #FF6B6B; border-color: rgba(255, 107, 107, 0.3); }
.reviewed-label { color: #1DD1A1; border-color: rgba(29, 209, 161, 0.3); }
.unreviewed-label { color: #FF6B6B; border-color: rgba(255, 107, 107, 0.3); }
.started-label { color: #1DD1A1; border-color: rgba(29, 209, 161, 0.3); }
.unstarted-label { color: #FF6B6B; border-color: rgba(255, 107, 107, 0.3); }

/* ==================== 分布图区域 ==================== */
.distribution-chart {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  gap: 2px;
}

.donut-chart-container {
  width: 100% !important;
  height: 100% !important;
  min-width: 0 !important;
  min-height: 0 !important;
  position: relative;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0;
  box-sizing: border-box;
  overflow: hidden;
}

/* 分布图标题 - 使用clamp()实现响应式字体缩放 */
.distribution-title {
  color: #cdddf7;
  /* 使用clamp()实现响应式字体：最小10px，理想值基于计算，最大12px */
  font-size: clamp(
    0.625rem,  /* 最小：10px */
    calc(0.6rem + 0.5vmin), /* 动态计算 */
    0.75rem    /* 最大：12px */
  );
  font-weight: bold;
  margin: 0;
  padding: 2px 0;
  text-align: center;
  background: linear-gradient(45deg, #00aeff, #74efff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  width: 100%;
  flex-shrink: 0;
  line-height: 1.2;
  box-sizing: border-box;
  /* 防止换行，超出显示... */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  position: relative;
  padding: 2px 4px;
  border-radius: 2px;
  background-color: rgba(5, 149, 235, 0.05);
  border: 1px solid rgba(5, 149, 235, 0.1);
  transition: all 0.3s ease;
}

.distribution-title:hover {
  background-color: rgba(5, 149, 235, 0.1);
  border-color: rgba(5, 149, 235, 0.2);
}

/* ==================== 响应式断点优化 ==================== */
/* 大屏幕（≥1200px） */
@media (min-width: 1200px) {
  .card-title {
    font-size: clamp(0.8rem, calc(0.8rem + 0.8vmin), 1.1rem);
  }
  
  .project-total {
    font-size: clamp(0.65rem, calc(0.65rem + 0.5vmin), 0.85rem);
  }
  
  .total-number {
    font-size: clamp(0.8rem, calc(0.8rem + 0.8vmin), 1.1rem);
  }
  
  .segment-label {
    font-size: clamp(0.55rem, calc(0.55rem + 0.4vmin), 0.75rem);
  }
  
  .distribution-title {
    font-size: clamp(0.65rem, calc(0.65rem + 0.5vmin), 0.85rem);
  }
}

/* 中等屏幕（768px-1199px） */
@media (min-width: 768px) and (max-width: 1199px) {
  .card-title {
    font-size: clamp(0.7rem, calc(0.7rem + 0.7vmin), 0.95rem);
  }
  
  .project-total {
    font-size: clamp(0.6rem, calc(0.6rem + 0.4vmin), 0.8rem);
  }
  
  .total-number {
    font-size: clamp(0.7rem, calc(0.7rem + 0.7vmin), 0.95rem);
  }
  
  .segment-label {
    font-size: clamp(0.5rem, calc(0.5rem + 0.35vmin), 0.7rem);
  }
  
  .distribution-title {
    font-size: clamp(0.6rem, calc(0.6rem + 0.4vmin), 0.8rem);
  }
  
  .dashboard-item {
    padding: 10px;
  }
  
  .segment-labels {
    gap: 3px;
  }
}

/* 小屏幕（<768px） */
@media (max-width: 767px) {
  .card-title {
    font-size: clamp(0.65rem, calc(0.65rem + 0.6vmin), 0.85rem);
  }
  
  .project-total {
    font-size: clamp(0.55rem, calc(0.55rem + 0.35vmin), 0.75rem);
  }
  
  .total-number {
    font-size: clamp(0.65rem, calc(0.65rem + 0.6vmin), 0.85rem);
  }
  
  .segment-label {
    font-size: clamp(0.45rem, calc(0.45rem + 0.3vmin), 0.65rem);
  }
  
  .distribution-title {
    font-size: clamp(0.55rem, calc(0.55rem + 0.35vmin), 0.75rem);
  }
  
  .dashboard-item {
    padding: 8px;
  }
  
  .project-header {
    margin-bottom: 6px;
    padding-bottom: 4px;
    gap: 6px;
  }
  
  .segment-labels {
    gap: 2px;
    padding: 0 1px;
  }
  
  .segment-label {
    padding: 1px 3px;
  }
  
  .distribution-chart {
    gap: 1px;
  }
}

/* 超小屏幕（<480px） */
@media (max-width: 479px) {
  .card-title {
    font-size: clamp(0.6rem, calc(0.6rem + 0.5vmin), 0.8rem);
  }
  
  .project-total {
    font-size: clamp(0.5rem, calc(0.5rem + 0.3vmin), 0.7rem);
  }
  
  .total-number {
    font-size: clamp(0.6rem, calc(0.6rem + 0.5vmin), 0.8rem);
  }
  
  .segment-label {
    font-size: clamp(0.4rem, calc(0.4rem + 0.25vmin), 0.6rem);
  }
  
  .distribution-title {
    font-size: clamp(0.5rem, calc(0.5rem + 0.3vmin), 0.7rem);
  }
  
  .dashboard-item {
    padding: 6px;
  }
  
  .dashboard-grid {
    gap: 6px;
  }
  
  .segment-labels {
    flex-wrap: wrap;
    justify-content: center;
  }
  
  .segment-label {
    flex: 0 0 auto;
    min-width: 60px;
    margin: 1px;
  }
}

/* 悬停文本溢出时的视觉增强 */
.card-title:hover,
.project-total:hover,
.total-number:hover,
.segment-label:hover,
.distribution-title:hover {
  text-decoration: underline;
  text-decoration-style: dotted;
  text-underline-offset: 2px;
  text-decoration-color: rgba(0, 174, 255, 0.5);
  z-index: 10; /* 确保悬浮提示在最上层 */
}

/* 确保所有容器都能正确收缩 */
.project-header *,
.segment-labels *,
.distribution-chart * {
  min-width: 0; /* 关键：允许内容收缩 */
}

/* 各种状态的颜色定义 - 增强对比度 */
.segment-won { 
  background: linear-gradient(90deg, #1DD1A1, #00e676);
  box-shadow: inset 0 0 4px rgba(29, 209, 161, 0.3);
}

.segment-inprogress { 
  background: linear-gradient(90deg, #FECA57, #FFA726);
  box-shadow: inset 0 0 4px rgba(254, 202, 87, 0.3);
}

.segment-lost { 
  background: linear-gradient(90deg, #FF6B6B, #ff4757);
  box-shadow: inset 0 0 4px rgba(255, 107, 107, 0.3);
}

.segment-normal { 
  background: linear-gradient(90deg, #1DD1A1, #00e676);
  box-shadow: inset 0 0 4px rgba(29, 209, 161, 0.3);
}

.segment-abnormal { 
  background: linear-gradient(90deg, #FF6B6B, #ff4757);
  box-shadow: inset 0 0 4px rgba(255, 107, 107, 0.3);
}

.segment-reviewed { 
  background: linear-gradient(90deg, #1DD1A1, #00e676);
  box-shadow: inset 0 0 4px rgba(29, 209, 161, 0.3);
}

.segment-unreviewed { 
  background: linear-gradient(90deg, #FF6B6B, #ff4757);
  box-shadow: inset 0 0 4px rgba(255, 107, 107, 0.3);
}

.segment-started { 
  background: linear-gradient(90deg, #1DD1A1, #00e676);
  box-shadow: inset 0 0 4px rgba(29, 209, 161, 0.3);
}

.segment-unstarted { 
  background: linear-gradient(90deg, #FF6B6B, #ff4757);
  box-shadow: inset 0 0 4px rgba(255, 107, 107, 0.3);
}

/* 增强进度条悬停效果 */
.segment-item:hover {
  opacity: 0.9;
  box-shadow: 0 0 8px rgba(255, 255, 255, 0.5), inset 0 0 8px rgba(255, 255, 255, 0.2);
  transform: scaleY(1.5); /* 悬停时稍微加粗 */
  z-index: 5; /* 确保在最上层 */
}
</style>


